// @ts-nocheck
import Application from '@/Application';
import { handleLoginRedirect } from '@/features/login/redirect';

export const startApplication = () => Application();

export { handleLoginRedirect };
